import {leaveChannel, subscribeToPrivateChannelEvents} from "@/utils/Sockets";
import {mapMutations, mapState} from "vuex";
import {getLabel} from "@/utils/Institution";
import {ApiUtils} from "@/utils/ApiUtils";
import {getFakeAvatar} from "@/utils/Common";


export default {
    data(vm){
        return {
            snackBar: false,
            snackBarColor: 'primary',
            snackBarText: '',
            snackBarClick: () => {},
            snackBarClickDefaultAction: () => {},
            loading: false,
            unattendedOnly: true,
            events: [],
            schedule: null
        }
    },
    mounted(){
        var vm = this
        vm.getEvents()
        const channel = `specialist.${vm.specialist}.appointments`
        leaveChannel(channel)
        setTimeout(() => {
            subscribeToPrivateChannelEvents(channel, {
                'ClientAttentionStart': vm.onClientAttentionStart,
                'ClientAttentionEnd': vm.onClientAttentionEnd,
                'EventCancelled': vm.onEventCancelled,
                'ClientArrived': vm.onClientArrive,
                'AppointmentCreated': vm.onAppointmentCreated,
                'EventLabelsUpdated': vm.onEventLabelsUpdated,
                'AppointmentConfirmed': vm.onAppointmentConfirmed,
            })
        }, 2000)

    },
    beforeRouteLeave(to, from, next){
        var vm = this
        vm.leaveSockets()
        next()
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        ...mapMutations('clientAttention', [
            'setEvent',
            'setDate'
        ]),
        getLabel,
        getFakeAvatar,
        leaveSockets(){
            var vm = this
            const channel = `specialist.${vm.specialist}.appointments`
            leaveChannel(channel)
        },
        onDateChange(date){
            this.setDate(date)
        },
        onAppointmentClick(event){
            console.log('appointment clicked: ', event)
            var vm = this
            const newEvent = JSON.parse(JSON.stringify(event))
            vm.setEvent(newEvent)
        },
        formatEvent(event){
            const evt = JSON.parse(JSON.stringify(event))
            evt.time = this.$moment(event.time, 'HH:mm').format('HH:mm')
            return evt
        },
        onEventCancelled({event}){


            var vm = this

            vm.snackBarClick = () => {
                vm.unattendedOnly = false
                vm.snackBarClickDefaultAction()
            }

            const eventIndex = vm.events.findIndex(evt => {
                return evt.id === event.id
            })

            if(eventIndex !== -1){
                const message = `Se ha cancelado la cita de las ${vm.$moment(event.time, 'HH:mm').format('HH:mm')}`
                vm.notify(message, 'pink')
                vm.events.splice(eventIndex, 1, vm.formatEvent(event))
            }

        },


        onClientArrive({event}){

            var vm = this
            vm.snackBarClick = () => {
                vm.unattendedOnly = true
                vm.snackBarClickDefaultAction()
            }

            const eventIndex = vm.events.findIndex(evt => {
                return evt.id === event.id
            })

            const message = `${event.client.first_name} ${event.client.last_name} (${vm.$moment(event.time, 'HH:mm').format('HH:mm')}) ha llegado`
            if(eventIndex !== -1){
                vm.notify(message, 'green')
                vm.events.splice(eventIndex, 1,  vm.formatEvent(event))
            }else{
                if(event.date === vm.date){
                    vm.notify(message, 'green')
                    vm.events.push(vm.formatEvent(event))
                }
            }

        },
        onEventLabelsUpdated({event}){
            const vm = this
            const {client} = event
            const message = `La atención de ${client.first_name} ${client.last_name} ha cambiado`
            const onToastClick = () => {
                vm.unattendedOnly = false
                vm.snackBarClickDefaultAction()
            }
            vm.updateClientListEvent(event, message, onToastClick)
        },
        onClientAttentionStart({event}){
            const vm = this
            const {client} = event
            const message = `La atención de ${client.first_name} ${client.last_name} ha comenzado`
            vm.updateClientListEvent(event, message);
        },
        onClientAttentionEnd({event}){
            const vm = this
            const message = `La atención de ${event.client.first_name} ${event.client.last_name} ha finalizado`
            vm.updateClientListEvent(event, message)
        },
        onAppointmentConfirmed({event}){
            const vm = this
            const onToastClick = () => {
                vm.unattendedOnly = false
                vm.snackBarClickDefaultAction()
            }
            const message = `Se ha confirmado la cita de las (${vm.$moment(event.time, 'HH:mm').format('HH:mm')})`
            vm.updateClientListEvent(event, message, onToastClick)
        },
        onAppointmentCreated({event}){
            const vm = this
            const onToastClick = () => {
                vm.unattendedOnly = false
                vm.snackBarClickDefaultAction()
            }
            const message = `Se ha agregó cita a las (${vm.$moment(event.time, 'HH:mm').format('HH:mm')})`
            vm.updateClientListEvent(event, message, onToastClick)
        },
        notify(message = '', color = ''){
            var vm = this
            vm.snackBarText = message
            vm.snackBarColor = color
            vm.snackBar = true
        },
        async getEvents(){
            var vm = this
            if(vm.loading) return
            vm.events = []
            if((vm.individualProvider && !vm.currentProvider) ||
                !vm.individualProvider && (!vm.currentProvider || !vm.currentBranchOffice)) {
                return
            }

            vm.loading = true
            const url = vm.individualProvider ?
                `provider/${vm.currentProvider.id}/appointments` :
                `provider/${vm.currentProvider.id}/branch-office/${vm.currentBranchOffice.id}/appointments`

            var response = await ApiUtils.makeGet(url, {
                date: vm.date,
                // status: vm.selectedAppointmentStatus.map(item => item.id),
                specialists: [vm.specialist] || []
            })

            if (!response.ok) {
                const json = await response.json()
                vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar citas')
                vm.loading = false
                return
            }

            const json = await
                response.json()
            const {data} = json.result.appointments
            vm.events = data
            vm.loading = false

        }
    },
    computed:{
        ...mapState([
            'currentUser',
            'currentProvider',
            'currentBranchOffice',
            'clientListIsVisible']),
        ...mapState('clientAttention', {
            currentEvent: state => state.currentEvent,
            date: state => state.currentDate,
        }),
        isInstitution(){
            var vm = this
            return !!vm.currentProvider && !!vm.currentProvider.institution
        },
        specialist(){
            var vm = this
            if(!vm.currentUser) return null
            return vm.specialistId  || vm.currentUser.id
        },
        items(){
            var vm = this
            if(vm.unattendedOnly){
                return vm.events.filter(event => {
                    return event.event_status_id === 3
                }).sort((a,b) => vm.$moment(
                    a.time, 'HH:mm') - vm.$moment(b.time, 'HH:mm')
                )
            }

            return vm.events.sort((a,b) => vm.$moment(
                a.time, 'HH:mm') - vm.$moment(b.time, 'HH:mm')
            )

        }
    },
    watch:{
        date(){
            this.getEvents()
        },
        events(val){
            const vm = this
            if(val && val.length > 0){
                vm.schedule = val[0].schedule_id || val[0].schedule.id
            }
            vm.$emit('change:events', val)
        },
        schedule(val, oldVal){},
        currentBranchOffice(val){
            this.getEvents()
        }
    }
}
